// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { PFixField } from './PFixField.js'
var PFixLongField = function (fieldId, buffer)
{
    this.Value = 0;
    PFixField.call(this, fieldId, buffer)
}

PFixLongField.prototype = Object.create(PFixField.prototype);

PFixLongField.prototype.ReadValue = function (buffer)
{
    this.Value = buffer.ReadInt64();
};

PFixLongField.prototype.Write = function (buffer)
{
    buffer.WriteShort(this.FieldId);
    buffer.WriteInt64(this.Value);
};

export { PFixLongField }